<template>
  <div class="wx-button" v-if="isSdkReady">
    <!-- iOS系统 并且需要传参的 用Universal Link -->
    <template v-if="isIOSPlatform && (type === 'reunion' || type === 'product')">
      <button class="button-action" :style="buttonStyle" @click="handleWxIOSClick">{{buttonTxt}}</button>
    </template>
    <!-- 其它情况 微信JSSDK打开 iOS不传参 android不传参 android传参 -->
    <template v-else>
      <button class="button-action" :style="buttonStyle" @click="openTips">{{buttonTxt}}</button>
    </template>
  </div>
  <div v-else>
    <button class="button-action__disabled" :style="buttonStyle">{{buttonTxt}}</button>
  </div>
</template>

<script>
import { isAndroid, isIOS, isWeixinVersion7012 } from '../../utils'
import wx from 'weixin-js-sdk'
import {  mapMutations } from "vuex";
import qs from 'qs'
export default {
  name: 'WxButton',
  props: {
    buttonStyle: {
      type: String,
      default: '',
    },
    buttonTxt: {
      type: String,
      default: '立即下载',
    },
    androidAPKUrl: {
      type: String,
      default: '',
    },
    itemNo: [String, Number],
    subKdtId: [String, Number],
    itemId: [String, Number],
    type: {
      type: String,
    },
    point: {
      type: String,
    },
  },
  data: () => {
    return {
      isSdkReady: false,
      extinfoStr: '',
      isIOSPlatform: isIOS()
    }
  },
  mounted(){
    console.log(this.itemNo,this.type)
    if(isAndroid()){
      if(this.type === 'default'){
        this.extinfoStr = ''
      }
    }
    if(isIOS()){
      this.extinfoStr =  ''
    }
    
    wx.ready(_ => {
      console.log('ready')
      if(isWeixinVersion7012()){
        this.isSdkReady = true
      } else {
        console.log("微信版本但是小于7.0.12")
        if(isIOS()){
          this.SET_IS_WX_ANDROID(true)
        }
        // if(isAndroid() ){
        //   window.location.href = this.androidAPKUrl
        // }
        // this.SET_IS_WX_ANDROID(true)
      } 
    }); 
  },
  methods:{
    ...mapMutations(['SET_IS_WX_ANDROID']),
    channelClickMonitor(){
      const utm_source = qs.parse(window.location.search, { ignoreQueryPrefix: true }).utm_source
      const code = this.$route.query.c || utm_source || ''
      console.log(code,'code')
      this.$sensors.track('channel_appDownloadPage_click', { code });
      // 参与页下载单独埋点
      if(this.type === 'participate' && this.point){
        console.log(this.point,'point')
        this.$sensors.track(this.point);
      }
    },
    handleError(e){
      console.log("handleError", e);
      this.channelClickMonitor()
      if(e.detail.errMsg === "launch:fail"){
        if(isIOS()){
          this.$toast({ message: '请在浏览器打开'});
          if(this.$config.env.VUE_APP_BRAND == "COTTI") {
            window.location.href = "https://apps.apple.com/cn/app/id1661236690";
          } else {
            window.location.href = "https://apps.apple.com/cn/app/id6473227178";
          }
        }
        if(isAndroid()){
          console.log(this.androidAPKUrl)
          window.location.href = this.androidAPKUrl
          // this.SET_IS_WX_ANDROID(true)
          // if(this.type === 'reunion' || this.type === 'product' ){
          //   this.$router.push({path: '/download'})
          // }
        }
      }
    },
    handleLaunch(e){
      console.log("handleLaunch", e);
      this.channelClickMonitor()
    },
    handleWxIOSClick(){
      console.log('wx-iOS')
      if(this.type === 'reunion'){
        return window.location.href = `https://www.cotticoffee.com/app/dj/pages/webView/webViewPage1?url=${window.location.origin}/#/reunion` // todo 需要替换链接
      }
      if(this.type === 'product'){
        return window.location.href = `https://www.cotticoffee.com/app/dj/pages/menu/productDetailPage?itemNo=${this.itemNo}&subKdtId=${this.subKdtId}&itemId=${this.itemId}` // todo 需要替换链接
      }
    },
    openTips() {
      if (isIOS()) {
        this.$toast({ message: '请在浏览器打开'});
        if(this.$config.env.VUE_APP_BRAND == "COTTI") {
          window.location.href = "https://apps.apple.com/cn/app/id1661236690";
        } else {
          window.location.href = "https://apps.apple.com/cn/app/id6473227178";
        }
      } else {
        this.SET_IS_WX_ANDROID(true)
      }
    }
  }
}
</script>

<style lang="scss">
.wx-button{
  position: relative;
  .button-action{
    background: #A52337;
    width: 542px;
    height: 90px;
    border-radius: 46px;
    box-shadow: 0px 2px 4px 0px rgba(143,92,92,0.12);
    font-size: 32px;
    font-weight: 500;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    outline: none;
  }
  .button-launch{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    .button-launch-app{
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
}
.button-action__disabled{
  width: 542px;
    height: 90px;
    border-radius: 46px;
    background: #A52337;
    font-size: 32px;
    font-weight: 500;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    outline: none;
}
</style>
